import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type VendorPaymentMethod } from '@webapp/modules/vendor/entities/VendorPaymentMethod'
import messages from './messages'
import { useMutateCreateVendorPaymentMethod } from '../../models'
import { type VendorPaymentMethodFormSchema } from '../../views/VendorPaymentMethodForm'

export interface IUseCreateVendorPaymentMethodFormPresenterParams {
  vendorId: number
  onCreated: (method: VendorPaymentMethod) => void
}

export const useCreateVendorPaymentMethodFormPresenter = ({
  vendorId,
  onCreated,
}: IUseCreateVendorPaymentMethodFormPresenterParams) => {
  const intl = useProcurifyIntl()
  const { createVendorPaymentMethod, isCreating } =
    useMutateCreateVendorPaymentMethod()

  const onSubmit = async (values: VendorPaymentMethodFormSchema) => {
    if (!values.type || !values.currency?.id) return

    try {
      const created = await createVendorPaymentMethod({
        vendorId,
        // Angular defaults an empty name to "New {type}".
        name: values.name.trim() || `New ${values.type.label}`,
        type: values.type.value,
        currencyId: values.currency.id,
      })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })

      onCreated(created)
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    }
  }

  return {
    states: {
      isCreating,
    },
    methods: {
      onSubmit,
    },
  }
}
